export default class SponsorPlanSelector {
    static init(){
        $('.checkbox-block input[type="checkbox"]').change(function() {
            let planId = $(this).attr('data-plan-id');
            let checked = $(this).prop('checked');
            let quantityBlock = document.querySelector('.quantity-block[data-plan-id="' + planId + '"]');
            if (checked){
                let quantity = document.querySelector('#plan-quantity-' + planId);
                if (quantity){
                    quantity.value = 1;
                }
                if (quantityBlock){
                    quantityBlock.classList.remove('d-none');
                }
            } else {
                if (quantityBlock){
                    quantityBlock.classList.add('d-none');
                }
            }
        });
    }
}
